<template>
  <span>
    <v-btn :color="buttonColor" @click="showDialog = true" :small="small" :icon="!buttonText">
      <v-icon v-if="buttonIcon" :left="buttonText">{{buttonIcon}}</v-icon>
      {{buttonText}}
    </v-btn>

    <v-dialog v-model="showDialog" max-width="600" :persistent="isDoingAction">
      <Card
        :icon="confirmationIcon"
        :title="confirmationText"
        inDialog
      >
        <v-card-actions>
          <v-spacer />
          <v-btn @click="showDialog = false" :disabled="isDoingAction">Cancel</v-btn>
          <v-btn :color="confirmationColor ? confirmationColor : buttonColor" @click="doAction" :loading="isDoingAction">
            <v-icon v-if="buttonIcon">{{buttonIcon}}</v-icon>
            {{confirmationButtonText ? confirmationButtonText : buttonText}}
          </v-btn>
        </v-card-actions>
      </Card>
    </v-dialog>
  </span>
</template>

<script>
  import Card from '@/components/Card'
  export default {
    name: 'ButtonWithConfirmation',
    components: { Card },
    props: {
      confirmationText: String,
      confirmationIcon: String,
      buttonText: String,
      buttonIcon: String,
      confirmationColor: String,
      confirmationButtonText: String,
      buttonColor: String,
      action: Function,
      successCallback: Function,
      small: Boolean,
    },

    data: () => ({
      showDialog: false,
      isDoingAction: false
    }),

    methods: {
      doAction() {
        this.isDoingAction = true;
        const result = this.action();

        if (result.then) {
          result.then(() => {
            this.isDoingAction = false;
            this.showDialog = false;
            if (this.successCallback)
              this.successCallback();
          });
          result.catch(() => {
            this.isDoingAction = false;
          });
        } else {
          this.isDoingAction = false;
          this.showDialog = false;
          if (this.successCallback)
            this.successCallback();
        }
      }
    }
  }
</script>

<style scoped>

</style>
